import GoogleReCAPTCHATos from "./GoogleReCAPTCHATos";

export default GoogleReCAPTCHATos;
